module.exports = __webpack_public_path__ + "static/img/monitor.50209d9d.png";